import styled from 'styled-components';
import { colors } from '../../themes';

export const StatusLedStyles = styled.div`
  span.led {
    cursor: pointer;
    display: inline-block;
    height: 13px;
    width: 13px;
    border-radius: 50%;
  }
  span.led-red {
    background-color: ${colors.lightColors.red};
  }
  span.led-green {
    background-color: ${colors.lightColors.green};
  }
  span.led-grey {
    background-color: ${colors.lightColors.grey};
  }
`;
